import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import {FormControl} from '@angular/forms';
import * as _ from 'lodash';

@Component({
    selector: 'app-forms-checkbox',
    //templateUrl: 'views/main.html'
    template: `
        <div class="file-control">
            <input id="{{formItem.key}}" [formControl]="controlItem" class="magic-checkbox" type="checkbox"
                (click)="onCheckBoxClicked()">
            <label for="{{formItem.key}}">
                <span *ngIf="this.showLabel">{{formItem.label}}</span>
            </label>
        </div>
    `
})
export class CheckBox implements OnInit, OnChanges {

    @Input()
    formItem: any;

    @Input()
    showLabel: boolean;

    @Input()
    float: boolean;

    @Output()
    selected: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    checkboxClickEmitter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    doUncheck: boolean;

    @Input()
    inputAttr: string;

    @Input()
    inputColor: string;

    @Input()
    inputBarAttr: string;

    @Input()
    isDisabled: boolean;

    @Input()
    isChecked: boolean;

    @Input()
    onDisable: EventEmitter<any> = new EventEmitter();

    controlItem: FormControl = new FormControl({value: false, disabled: false});
    constructor() {
    }

    ngOnInit(){
        if(!_.isEmpty(this.formItem.value) || this.isChecked)
            this.controlItem.setValue(true);

        if(this.isDisabled)
            this.controlItem
                .reset({value: false, disabled: true});

        if(!_.isEmpty(this.formItem.validators)){
            this.controlItem.setValidators(this.formItem.validators);
            this.controlItem.valueChanges.subscribe(() => {
                if(!this.controlItem.value) {
                    this.controlItem.setErrors({required: true})
                }
            });
        }
        this.selected.emit(this.controlItem);
        this.onDisable.subscribe(disable =>
            disable
                ? this.controlItem.disable()
                : this.controlItem.enable()
        )

    }

    ngOnChanges(changes: SimpleChanges) {
        if(this.doUncheck) {
            this.controlItem.setValue(!this.doUncheck);
            this.doUncheck = undefined;
        }
    }

    onCheckBoxClicked() {
        setTimeout(() => {
            let selectedItemId = this.formItem.key.substring(7, this.formItem.key.length);
            this.checkboxClickEmitter.emit({
                id: selectedItemId,
                value: this.controlItem.value
            });
        }, 100);
    }

}
